import React, { useEffect } from "react";

const FeaturedTrends = () => {
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .featured-section {
        width: 100%;
        padding: 64px 20px;
        background: #fafbfc;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      }

      .featured-container {
        max-width: 1200px;
        width: 100%;
      }

      .featured-eyebrow {
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 1.6px;
        text-transform: uppercase;
        color: #0d7a93;
        margin-bottom: 8px;
      }

      .featured-title {
        font-size: 26px;
        font-weight: 800;
        margin: 0 0 36px 0;
        text-align: left;
        color: #0d0d3f;
        letter-spacing: -0.3px;
        font-family: 'Montserrat', sans-serif;
      }

      /* Main container for all cards */
      .cards-container {
        display: flex;
        gap: 22px;
        justify-content: space-between;
        align-items: stretch;
        animation: slideUp 0.5s ease-out;
      }

      /* ===== Article Cards ===== */
      .article-card {
        background: #fff;
        border-radius: 14px;
        box-shadow: 0 6px 20px rgba(15, 23, 42, 0.06);
        border: 1px solid rgba(15, 23, 42, 0.05);
        overflow: hidden;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        cursor: pointer;
        width: 30%;
        display: flex;
        flex-direction: column;
        height: 460px;
        position: relative;
      }

      .article-card:hover {
        transform: translateY(-6px);
        box-shadow: 0 16px 36px rgba(15, 23, 42, 0.12);
      }

      .article-card .img-wrap {
        width: 100%;
        height: 190px;
        overflow: hidden;
      }

      .article-card img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        transition: transform 0.4s ease;
      }

      .article-card:hover img {
        transform: scale(1.07);
      }

      .article-content {
        padding: 20px 22px 22px 22px;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        justify-content: space-between;
      }

      .article-date {
        font-size: 11.5px;
        font-weight: 700;
        letter-spacing: 0.6px;
        text-transform: uppercase;
        color: #0d7a93;
        margin-bottom: 10px;
      }

      .article-title {
        font-size: 15.5px;
        font-weight: 700;
        margin-bottom: 10px;
        color: #14213d;
        line-height: 1.4;
        letter-spacing: -0.1px;
      }

      .article-desc {
        font-size: 13px;
        font-weight: 400;
        color: #6b7280;
        line-height: 1.6;
        margin-top: 2px;
      }

      .read-more {
        position: absolute;
        bottom: 20px;
        right: 22px;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.3px;
        color: #0d7a93;
        cursor: pointer;
        opacity: 0;
        transform: translateX(-6px);
        transition: opacity 0.3s ease, transform 0.3s ease;
      }

      .article-card:hover .read-more {
        opacity: 1;
        transform: translateX(0);
      }

      /* ===== Event Cards ===== */
      .event-card {
        background: #10243a;
        border-radius: 14px;
        overflow: hidden;
        cursor: pointer;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        width: 100%;
        height: 219px;
        position: relative;
        box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
      }

      .event-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 14px 30px rgba(15, 23, 42, 0.16);
      }

      .event-card img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.4s ease, opacity 0.3s ease;
      }

      .event-card:hover img {
        transform: scale(1.06);
        opacity: 0.25;
      }

      .event-overlay {
        position: absolute;
        inset: 0;
        background: linear-gradient(180deg, rgba(13,23,42,0.2) 0%, rgba(13,23,42,0.92) 100%);
        color: white;
        opacity: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transition: opacity 0.3s ease;
        padding: 18px;
        text-align: center;
      }

      .event-card:hover .event-overlay {
        opacity: 1;
      }

      .event-date {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.6px;
        text-transform: uppercase;
        color: #e8b923;
        margin-bottom: 8px;
      }

      .event-title {
        font-size: 15px;
        font-weight: 700;
        line-height: 1.35;
        margin-bottom: 8px;
      }

      .event-description {
        font-size: 12px;
        font-weight: 400;
        color: #cbd5e1;
        line-height: 1.55;
      }

      @keyframes slideUp {
        0% {
          transform: translateY(24px);
          opacity: 0;
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }

      /* ===== Responsive Layout ===== */
      @media (max-width: 992px) {
        .cards-container {
          flex-wrap: wrap;
          gap: 18px;
        }

        .article-card {
          width: 48%;
          height: 430px;
        }

        .events-column {
          width: 100% !important;
          flex-direction: row !important;
        }

        .event-card {
          width: 100%;
          height: 200px;
        }
      }

      @media (max-width: 768px) {
        .featured-section {
          padding: 44px 16px;
        }

        .featured-title {
          font-size: 20px;
          margin-bottom: 26px;
        }

        .cards-container {
          flex-direction: column;
          align-items: stretch;
        }

        .article-card {
          width: 100%;
          height: auto;
          min-height: 380px;
        }

        .article-card .img-wrap {
          height: 170px;
        }

        .article-title {
          font-size: 14.5px;
        }

        .article-date {
          font-size: 11px;
        }

        .article-desc {
          font-size: 12.5px;
        }

        .events-column {
          width: 100% !important;
          flex-direction: column !important;
        }

        .event-card {
          width: 100%;
          height: 190px;
          margin-left: 0;
        }

        .event-title {
          font-size: 14px;
        }

        .event-description {
          font-size: 11.5px;
        }
      }

      @media (max-width: 400px) {
        .article-card {
          min-height: 360px;
        }
        .article-card .img-wrap {
          height: 150px;
        }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const articles = [
    {
      id: 1,
      img: "/image/aiii.jpg",
      date: "Article | August 7, 2025",
      title:
        "Envision reimagines onboarding with GenAI for a better employee experience",
      desc: "Generative AI empowers professionals to create transformative, efficient solutions in employee onboarding.",
    },
    {
      id: 2,
      img: "/image/Doctor-at-computer-hologram-illustration_1.jpg",
      date: "Article | August 5, 2025",
      title:
        "Sustainability meets humanity: How Envision is future-proofing its people and purpose",
      desc: "Exploring how long-term investments in wellbeing, equity, and innovation reshape impact.",
    },
  ];

  const events = [
    {
      id: 3,
      img: "/image/Cloud-Computing-1.jpg",
      date: "Event | September 3-4 | Boston",
      title: "Envision Veeva Summit, US 2025",
      description:
        "Join us to explore the latest advancements in cloud computing technologies and how they're transforming business operations across industries.",
    },
    {
      id: 4,
      img: "/image/digitalmarket.webp",
      date: "Event | September 8-10 | Denver",
      title: "Envision at SAP for Utilities 2025",
      description:
        "Discover cutting-edge digital marketing strategies and tools that are reshaping customer engagement and driving business growth in the digital age.",
    },
  ];

  return (
    <div className="featured-section">
      <div className="featured-container">
        <p className="featured-eyebrow">Latest Updates</p>
        <h2 className="featured-title">Featured Trends and Insights</h2>

        <div className="cards-container">
          {/* First Article Card */}
          <div className="article-card">
            <div className="img-wrap">
              <img src={articles[0].img} alt={articles[0].title} />
            </div>
            <div className="article-content">
              <div>
                <div className="article-date">{articles[0].date}</div>
                <div className="article-title">{articles[0].title}</div>
                <div className="article-desc">{articles[0].desc}</div>
              </div>
              <span className="read-more">Read More →</span>
            </div>
          </div>

          {/* Second Article Card */}
          <div className="article-card">
            <div className="img-wrap">
              <img src={articles[1].img} alt={articles[1].title} />
            </div>
            <div className="article-content">
              <div>
                <div className="article-date">{articles[1].date}</div>
                <div className="article-title">{articles[1].title}</div>
                <div className="article-desc">{articles[1].desc}</div>
              </div>
              <span className="read-more">Read More →</span>
            </div>
          </div>

          {/* Event Cards */}
          <div
            className="events-column"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "30%",
              gap: "20px",
            }}
          >
            {events.map((item) => (
              <div key={item.id} className="event-card">
                <img src={item.img} alt={item.title} />
                <div className="event-overlay">
                  <div className="event-date">{item.date}</div>
                  <div className="event-title">{item.title}</div>
                  <div className="event-description">
                    {item.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedTrends;